"use strict";

angular.module("vendor")
.factory("SupplierUserInfoService", function($rootScope, $http, appConfig) {
    return {
        updateVendorProductViewSelected: function(value) {
            $http({
                method: "PATCH",
                ignoreLoadingBar: true,
                url: appConfig.API_SERVER + "/catalog/vendor/products/views/edit/",
                data: {
                    vendor_product_view_selected: value
                }
            }).then(function(response) {
                $rootScope.user.info.vendor_product_view_selected = response.data.vendor_product_view_selected;
            });
        },
        getManufacturers: function() {
            return $http.get(appConfig.API_SERVER + "/auth/vendor/manufacturers/");
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/auth/user-info.factory.js
// module id = 978
// module chunks = 0